<div class="wrapper">
  <img *ngIf="logo" (error)="logo = false" class="logo" [src]="logo" />
  <img *ngIf="!logo" class="logo" src="/resources/img/default-avatar.svg">
  <div class="title-container">
    <div class="title">{{ title }}</div>
	<a [href]="url" target="_blank">{{ url }}</a>
	<div class="authentication-status">
		<span class="authenticate-success" *ngIf="authentication === false"><i class="fa-regular fa-check"></i>{{ 'AUTHENTICATED' | translate }}</span>
		<span class="authenticate-expired" *ngIf="authentication === true"><i class="fa-regular fa-xmark"></i>{{ 'AUTHENTICATION_EXPIRED' | translate }}</span>
	</div>
  </div>
</div>

